import { Component, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PriceTooltipComponent } from './price-tooltip/price-tooltip.component';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-product-price-cell-renderer',
  templateUrl: './product-price-cell-renderer.component.html',
  styleUrls: ['./product-price-cell-renderer.component.scss']
})
export class ProductPriceCellRendererComponent implements OnDestroy{
  private destroy$ = new Subject<void>();
  params;
  dialogRef;
  price;
  constructor(private dialog: MatDialog) {}

  agInit(params: any): void {
    this.params = params;
    this.price=params.value;
  }

  openDialog(e: MouseEvent) {
    const target = e.target as any;
    const targetPosision = target.getBoundingClientRect();
    this.dialogRef = this.dialog.open(PriceTooltipComponent, {
      hasBackdrop: false,
      position: {
        left: targetPosision.right - 35 + "px",
        top: targetPosision.top + 20 + "px",
      },
      panelClass: 'price-dialog-container',
      width: "150px",
      data: this.params.data
    });
  }

  closeDialog(e) {
    this.dialogRef.close();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
